import React, { createContext, useContext, useState } from 'react';

const TitularContext = createContext({});

export function useDependente() {
    const context = useContext(TitularContext);

    return context;
}

export function DependentesProvider({ children }) {
    const [dataDependentes, setDataDependentes] = useState([]);
    const [kinshipDegreeOptions, setKinshipDegreeOptions] = useState({});

    function clearDependente() {
        setDataDependentes([]);
        setKinshipDegreeOptions({});
    }

    return (
        <TitularContext.Provider value={{ 
            dataDependentes, 
            setDataDependentes, 
            kinshipDegreeOptions,
            setKinshipDegreeOptions, 
            clearDependente 
        }}>
            {children}
        </TitularContext.Provider>
    );
}
